/**
 * Resets the state of the active UI component when the ESC key is pressed.
 * @param {Event} event - The keyboard event object.
 * @param {Object} config - Configuration object for specifying selectors and classes.
 */

// TODO - If focus is on nested element (e.g. in search results) ESC does not currently trigger a closing event.
// ? Need to modify so can traverse up the DOM tree to find the parent component that needs triggering

export function handleEscKey(event, config) {
    if (event.key === "Escape") {
        const openComponents = document.querySelectorAll(config.openSelector);

        openComponents.forEach((component) => {
            const menu = component.querySelector(config.menuSelector);
            if (menu) {
                menu.hidden = true;
                component.classList.remove(config.openClass);

                const focusElement = component.querySelector(
                    config.focusSelector,
                );
                if (focusElement) {
                    focusElement.focus();
                }
            }
        });
    }
}
